import { getRoleLabel } from "./careerIntentCatalog";
import { getCareerIntentSummaryRows, type CareerIntentFormValues } from "./careerIntentForm";

export default function CareerIntentSummarySection({
  includeNotes = true,
  values
}: {
  includeNotes?: boolean;
  values: CareerIntentFormValues;
}) {
  const rows = getCareerIntentSummaryRows(values, includeNotes);

  return (
    <div data-testid="career-intent-summary">
      <h3 className="mb-4 text-title-medium text-sys-brand-on-surface">Your answers so far</h3>
      {rows.map((row) => {
        const displayValues =
          row.label === "Target positions" ? row.values.map((value) => getRoleLabel(value) ?? value) : row.values;
        const isNotes = row.label === "Notes for your consultant";

        return (
          <div className="mb-5" key={row.label}>
            <p className="mb-2 text-label-large text-sys-brand-on-surface-variant">{row.label}</p>
            {isNotes ? (
              <p className="text-body-large text-sys-brand-on-surface">{displayValues[0]}</p>
            ) : (
              <div className="flex flex-row flex-wrap">
                {displayValues.map((value) => (
                  <span
                    className="mb-2 mr-2 rounded-full border border-sys-brand-primary/30 bg-sys-brand-primary/5 px-3 py-2 text-label-large text-sys-brand-primary"
                    key={value}
                  >
                    {value}
                  </span>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
